import React from "react";
import InfoDot from "./InfoDot";

// Paket Injuries (Marin 16.09.2026): the player's current availability as ONE pill in the hero basic-info
// row, next to the GBE pill — texts exactly like ScoutPitch (`availabilityView` in src/lib/profile.js):
// "Injured · expected back ~12 Oct", "Suspended · 2 matches", "Doubtful". fit / unknown → nothing
// (the null rule: no pill is a statement, a dash is not). The InfoDot carries reason, since and as-of.
//
// Payload (GET /dashboard/players/{id}/injuries/ → availability):
//   { status: fit|injured|suspended|questionable|unknown, reason, since, expected_return, missed_matches, as_of, basis }

const TONES = {
  injured: { bg: "#FEF3C7", fg: "#B45309", label: "Injured" },
  questionable: { bg: "#FEF3C7", fg: "#B45309", label: "Doubtful" },
  suspended: { bg: "#FEE2E2", fg: "#DC2626", label: "Suspended" },
};

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const fmtShort = (iso, withYear = false) => {
  if (!iso) return "";
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00Z` : iso);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getUTCDate()} ${MONTHS[d.getUTCMonth()]}${withYear ? ` ${d.getUTCFullYear()}` : ""}`;
};
const matches = (n) => `${n} match${n === 1 ? "" : "es"}`;

export const availabilityText = (a) => {
  const tone = TONES[a?.status];
  if (!tone) return null;
  let label = tone.label;
  if ((a.status === "injured" || a.status === "questionable") && a.expected_return) label += ` · expected back ~${fmtShort(a.expected_return)}`;
  if (a.status === "suspended" && a.missed_matches) label += ` · ${matches(a.missed_matches)}`;
  const note = [
    a.reason,
    a.since ? `since ${fmtShort(a.since)}` : "",
    a.status !== "suspended" && a.missed_matches ? `${matches(a.missed_matches)} missed` : "",
  ].filter(Boolean).join(" · ");
  return { label, note, tone, asOf: a.as_of ? `as of ${fmtShort(a.as_of, true)}` : "" };
};

const AvailabilityPill = ({ availability }) => {
  const v = availabilityText(availability);
  if (!v) return null;
  const body = [v.note ? `${v.note}.` : null, v.asOf ? `Platform data ${v.asOf}.` : "From platform data.", "Availability and injury history also live in ScoutPitch."]
    .filter(Boolean)
    .join(" ");
  return (
    <div className="flex items-center gap-1" data-testid="availability-pill">
      <span
        className="inline-flex items-center text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap"
        style={{ background: v.tone.bg, color: v.tone.fg }}
        title={v.note || undefined}
      >
        {v.label}
      </span>
      <InfoDot title="Availability" body={body} ariaLabel="About the availability" />
    </div>
  );
};

export default AvailabilityPill;
